// utils/trackingPixels/events.ts - utils/trackingPixels.ts split (sub-module events)


import { getUserIdentifier } from './dedupe.js';
import { trackAnalyticsEvent } from './track.js';


export async function trackPageView(productId?: string, productName?: string, brandId?: string) {
    await trackAnalyticsEvent('page_view', 'landing_page', null, { productId, brandId, eventData: { productName, pageUrl: window.location.href, referrer: document.referrer } });
}



export async function trackFormView(formId: string, formTitle: string, productId?: string, brandId?: string, customerPhone?: string, customerEmail?: string) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('form_view', 'form', userIdentifier, { formId, productId, brandId, eventData: { formTitle, customerPhone, customerEmail } });
}



export async function trackFormSubmit(formId: string, formTitle: string, orderId?: string, productId?: string, productName?: string, brandId?: string, customerPhone?: string, customerEmail?: string, customerName?: string, variant?: string, quantity?: number, totalPrice?: number) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('form_submit', 'form', userIdentifier, { formId, productId, orderId, brandId, eventData: { formTitle, productName, customerPhone, customerEmail, customerName, variant, quantity, totalPrice } });
}



export async function trackFormAbandon(formId: string, formTitle: string, productId?: string, brandId?: string, customerPhone?: string, customerEmail?: string, timeSpentSeconds?: number) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('form_abandon', 'form', userIdentifier, { formId, productId, brandId, eventData: { formTitle, customerPhone, customerEmail, timeSpentSeconds } });
}



export async function trackCheckoutInitiated(productId: string, productName: string, orderId: string, customerPhone?: string, customerEmail?: string, customerName?: string, totalPrice?: number) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('checkout_initiated', 'form', userIdentifier, { orderId, eventData: { digitalProductId: productId, productName, customerPhone, customerEmail, customerName, totalPrice } });
}



export async function trackPaymentView(productId: string, productName: string, orderId: string, totalPrice?: number) {
    await trackAnalyticsEvent('payment_view', 'order', null, { orderId, eventData: { digitalProductId: productId, productName, totalPrice } });
}



export async function trackPurchaseComplete(productId: string, productName: string, orderId: string, totalPrice: number, customerPhone?: string, customerEmail?: string) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('purchase_complete', 'order', userIdentifier, { orderId, eventData: { digitalProductId: productId, productName, totalPrice, customerPhone, customerEmail } });
}
